var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfileIcon = function SvgProfileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.185.5a7.494 7.494 0 0 1 7.5 7.488c-.213 4.29-3.717 7.444-7.49 7.512-4.529-.258-7.45-3.716-7.51-7.504A7.494 7.494 0 0 1 12.185.5Zm0 28c-3.242 0-6.17-.265-8.273-1.01-1.049-.371-1.856-.85-2.399-1.441-.532-.58-.828-1.291-.828-2.186s.298-1.603.831-2.18c.545-.589 1.356-1.063 2.406-1.43 2.108-.736 5.038-.992 8.263-.992 3.241 0 6.17.265 8.273 1.01 1.048.371 1.856.85 2.398 1.441.532.58.829 1.291.829 2.186s-.298 1.603-.832 2.18c-.545.589-1.356 1.063-2.406 1.43-2.108.736-5.038.992-8.262.992Z",
    fill: "#212529",
    stroke: "#212529"
  })));
};
export default SvgProfileIcon;